// assets
import { IconDashboard, IconFileInvoice, IconList, IconSquarePlus } from '@tabler/icons';

// constant
const icons = { IconDashboard, IconFileInvoice, IconList, IconSquarePlus };

// ==============================|| DASHBOARD MENU ITEMS ||============================== //
const permissionsString = sessionStorage.getItem('permissions') || '0';
function strcmp(a, b) {
    // a = a.toString(), b = b.toString();
    let i;
    const n = Math.max(a.length, b.length);
    for (i = 0; i < n && a.charAt(i) === b.charAt(i); i += 1);
    if (i === n) return 0;
    return a.charAt(i) > b.charAt(i) ? -1 : 1;
}
let myitems;
if (strcmp(permissionsString, '3') === 0) {
    // agent
    myitems = [
        {
            id: 'default',
            title: 'Orders',
            type: 'item',
            url: '/',
            icon: icons.IconList,
            breadcrumbs: false
        },
        {
            id: 'create-order',
            title: 'Create order',
            type: 'item',
            url: '/order',
            icon: icons.IconSquarePlus,
            breadcrumbs: false
        }
    ];
} else if (strcmp(permissionsString, '1') === 0) {
    // employee
    myitems = [
        {
            id: 'default',
            title: 'Orders',
            type: 'item',
            url: '/',
            icon: icons.IconList,
            breadcrumbs: false
        },
        {
            id: 'create-order',
            title: 'Create order',
            type: 'item',
            url: '/order',
            icon: icons.IconSquarePlus,
            breadcrumbs: false
        }
    ];
} else if (strcmp(permissionsString, '2') === 0) {
    // supplier
    myitems = [
        {
            id: 'default',
            title: 'Orders',
            type: 'item',
            url: '/',
            icon: icons.IconList,
            breadcrumbs: false
        }
    ];
} else if (strcmp(permissionsString, '4') === 0) {
    // driver
    myitems = [
        {
            id: 'default',
            title: 'Orders',
            type: 'item',
            url: '/',
            icon: icons.IconList,
            breadcrumbs: false
        }
    ];
} else {
    // client
    myitems = [
        {
            id: 'default',
            title: 'Orders',
            type: 'item',
            url: '/',
            icon: icons.IconList,
            breadcrumbs: false
        },
        {
            id: 'create-order',
            title: 'Create order',
            type: 'item',
            url: '/order',
            icon: icons.IconSquarePlus,
            breadcrumbs: false
        }
    ];
}

// const dashboard = {
//     id: 'dashboard',
//     title: 'Dashboard',
//     type: 'group',
//     children: [
//         {
//             id: 'default',
//             title: 'Orders',
//             type: 'item',
//             url: '/',
//             icon: icons.IconList,
//             breadcrumbs: false
//         },
//         {
//             id: 'create-order',
//             title: 'Create order',
//             type: 'item',
//             url: '/order',
//             icon: icons.IconSquarePlus,
//             breadcrumbs: false
//         }
//     ]
// };
const dashboard = {
    id: 'dashboard',
    title: 'Dashboard',
    type: 'group',
    children: myitems
};

export default dashboard;
